<template>
  <div id="action-box">
    <div v-if="!flag">
      <div class="new-price" v-if="checkDiffAmount(diffAmount, approvedAmount)">{{ addCommas(newPrice) }}</div>
      <div class="icon toggle-text-input" @click="() => changeFlag()">
        <font-awesome-icon :icon="faArrowDown" />
      </div>
    </div>
    <div v-if="flag" class="flag">
      <div class="text" >
        <text-input
          type="positiveNumber"
          v-model="newPrice"
          ref="newPriceInput"
          required
          @keyup.enter="() => updateNewPrice()"
          borderbottom
          :hint="newPriceHint"
        >
        </text-input>
      </div>
      <div class="icon submit" @click="() => updateNewPrice()">
        <font-awesome-icon :icon="faCheckCircle" />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, getCurrentInstance } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons';

import { changeDigitToViText, addCommas } from '@/helpers';

import { MILLION } from '@/consts';

import TextInput from '@/components/TextInput';

import ValueAdjustmentListService from '../ValueAdjustmentListServices';

const { useActions: useFlashActions } = createNamespacedHelpers('flash');
const { useActions } = createNamespacedHelpers('valueAdjustmentList');

export default {
  name: 'ActionBox',
  components: {
    FontAwesomeIcon,
    TextInput
  },
  props: {
    contractId: Number,
    diffAmount: Number,
    approvedAmount: Number,
  },
  setup(props) {
    const vm = getCurrentInstance();
    const { info, error } = useFlashActions(['info', 'error']);
    const { getContractList } = useActions(['getContractList']);
    const flag = ref(false);
    const newPrice = ref(0);
    const newPriceInput = ref(null);
    const newPriceHint = computed(() => (changeDigitToViText(newPrice.value)));

    const checkDiffAmount = (inputDiffAmount, inputApprovedAmount) => {
      if(inputDiffAmount) {
        newPrice.value = inputApprovedAmount - inputDiffAmount;
        return true;
      }
      newPrice.value = inputApprovedAmount;
      return false;
    };

    const changeFlag = () => {
      flag.value = !flag.value;
      newPrice.value /= MILLION;
    };

    const validateNewPrice = () => {
      if (newPrice.value * MILLION <= props.approvedAmount) {
        return true;
      }
      newPriceInput.value.alert(vm.$i18n.t('NEWPRICE_GREATER_OLDPRICE'));
      return false;
    };

    const updateNewPrice = async () => {
      let valid = true;
      valid = valid && newPriceInput.value.validateInput() && validateNewPrice();

      if(valid) {
        const newDiffAmout = computed(() => (props.approvedAmount - newPrice.value * MILLION));

        try {
          await ValueAdjustmentListService.updateNewPrice(props.contractId, newDiffAmout.value);
          info('NEW_PRICE_UPDATE_SUCCESS');
          getContractList();
          flag.value = !flag.value;
        } catch(err) {
          error(err);
        }
      }
    };

    return {
      faCheckCircle,
      faArrowDown,
      newPrice,
      newPriceInput,
      newPriceHint,
      checkDiffAmount,
      flag,
      updateNewPrice,
      MILLION,
      addCommas,
      changeFlag
    };
  }
};
</script>

<style lang="scss">
@import "~@/assets/scss/colors";

#action-box {

    .icon {
      display: inline-block;
      width: 32px;
      height: 32px;
      text-align: center;
      position: relative;
      cursor: pointer;
      transition: all .2s ease-in-out;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: $alto;
        border-radius: 50%;
        opacity: .2;
        transition: all .2s ease-in-out;
      }

      svg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
      }

      &:hover,

      &.toggle-text-input {
        margin: 0 5px;
        transition: all .2s ease-in-out;

        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: $tuftsBlue;
          border-radius: 50%;
          opacity: .2;
          transition: all .2s ease-in-out;
        }

        svg {
          color: $tuftsBlue;
          position: absolute;
          width: 17px;
          height: 17px;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
          transition: all .2s ease-in-out;
        }

        &:hover {
          &::before {
            opacity: 1;
          }

          svg {
            color: $babyPowder;
          }
        }
      }

      &.submit {
        margin: 0 5px;
        transition: all .2s ease-in-out;

        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: $shamrockGreen;
          border-radius: 50%;
          opacity: .2;
          transition: all .2s ease-in-out;
        }

        svg {
          color: $shamrockGreen;
          position: absolute;
          width: 17px;
          height: 17px;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
          transition: all .2s ease-in-out;
        }
      }
    }
  .flag{

    .text {
      display: inline;

      .borderbottom {
        width: 65px;

        input {
          text-align: center;
        }
      }

      small {
        font-size: 65%;
      }
    }
  }

  .new-price {
    position: relative;
    display: inline;
    bottom: 8px;
  }
}

</style>
